/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityBatchTrxDetailInfo = {
    BTNO: string;
    BS: HumanityBatchTrxDetailInfo.BS;
    BPS: HumanityBatchTrxDetailInfo.BPS;
    AG: string;
    UT: number;
    DM: string;
    TRXCNT: string;
    BCNT: string;
    CMTRX: string;
    CFTRX: string;
    L1BN: string;
    BFACC: string;
    AFACC: string;
    FMN: string;
    LMN: string;
    MSGCNT: string;
};

export namespace HumanityBatchTrxDetailInfo {

    export enum BS {
        FINALIZED = 'FINALIZED',
        UNFILALIZED = 'UNFILALIZED',
    }

    export enum BPS {
        PROCESSED_ON_L2 = 'PROCESSED_ON_L2',
        POSTED_ON_L1 = 'POSTED_ON_L1',
        CONFIRMED_ON_L1 = 'CONFIRMED_ON_L1',
    }


}

